import React, { Fragment } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import './AddEditReferralsRequest.Header.scss';
import { PrimaryButton, SecondaryButton } from 'v3/Components/Shared/Buttons';

export type AddEditReferralsRequestFooterProps = {
  onDiscard: () => void;
  onSaveDraft: () => void;
  savingDraft?: boolean;
  lob?: string;
  showDiscardButton?: boolean;
  isUploadingFiles?: boolean;
};

const AddEditReferralsRequestFooter: React.FC<
  AddEditReferralsRequestFooterProps
> = ({
  onDiscard,
  onSaveDraft,
  lob,
  savingDraft,
  showDiscardButton,
  isUploadingFiles,
}) => {
  return (
    <Fragment>
      {showDiscardButton && (
        <SecondaryButton
          title="Discard Draft"
          className="centered no-border"
          onClick={onDiscard}
        />
      )}
      <SecondaryButton
        title="Save Draft & Finish Later"
        onClick={onSaveDraft}
        className="centered"
        disabled={savingDraft || isUploadingFiles}
      />
    </Fragment>
  );
};

export default AddEditReferralsRequestFooter;
